import { combineLatest, Observable } from 'rxjs';
import Fuse from 'fuse.js';
import { fuse } from '~utilities/fuse';
import { map, shareReplay, startWith } from 'rxjs/operators';
import FuseOptionKey = Fuse.FuseOptionKey;

export class FusedObservable<T> {
  private readonly fusedInternal$: Observable<T[]>;

  public get fused$(): Observable<T[]> {
    return this.fusedInternal$;
  }

  public constructor(
    toFuse$: Observable<T[]>,
    searchObservable$: Observable<any>,
    options: Fuse.IFuseOptions<T> | FuseOptionKey<T>[],
  ) {
    if (Array.isArray(options)) {
      options = {
        distance: 1000,
        keys: options,
        location: 0,
        minMatchCharLength: 1,
        threshold: 0.2,
      } as Fuse.IFuseOptions<T>;
    }
    this.fusedInternal$ = combineLatest([toFuse$.pipe(map(fuse(options))), searchObservable$.pipe(startWith(''))]).pipe(
      map(([data, search]) => {
        if (!search) {
          return data.data;
        }
        return data.fuse.search(search).map((v) => v.item);
      }),
      shareReplay(1),
    );
  }
}
